import React from 'react'
import Header from '../../Components/Header'

function Echarts() {
  return (
    <>
    <Header/>
    </>
  )
}

export default Echarts